import { render, staticRenderFns } from "./reviewDetailModal.vue?vue&type=template&id=38a107c6&scoped=true"
import script from "./reviewDetailModal.vue?vue&type=script&lang=js"
export * from "./reviewDetailModal.vue?vue&type=script&lang=js"
import style0 from "./reviewDetailModal.vue?vue&type=style&index=0&id=38a107c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a107c6",
  null
  
)

export default component.exports